module.exports = __webpack_public_path__ + "static/media/home.b32405f4.png";